<template>
  <section>
    <SharedPageHeaderTitle :title="t('pages.features.website.headerTitle')" />

    <div class="base-container-first website__wrapper">
      <ul class="website__cards">
        <li
          v-for="(card, cardIndex) in CARDS"
          :key="cardIndex"
        >
          <SharedPageCard
            isWhite
            :card
          />
        </li>
      </ul>

      <SharedPageBusiness :business-list="BUSINESSES" />

      <ul class="website__cards">
        <li
          v-for="(advantage, advantageIndex) in ADVANTAGES"
          :key="advantageIndex"
        >
          <SharedPageCard
            isWhite
            :card="advantage"
          />
        </li>
      </ul>
    </div>
  </section>

  <ContactOrderForm
    :description="t('pages.features.website.managerDescription')"
    :title="t('pages.features.website.questionsTitle')"
  />
</template>

<script setup lang="ts">
const { t, locale } = useI18n();

const CARDS = computed(() => [
  {
    description: t("pages.features.website.cards.simple.description"),
    image: "website-card-1",
    title: t("pages.features.website.cards.simple.title"),
  },
  {
    description: t("pages.features.website.cards.oneColor.description"),
    image: "website-card-2",
    title: t("pages.features.website.cards.oneColor.title"),
  },
]);

const BUSINESSES = computed(() => [
  t("pages.features.website.businesses.beautySalon"),
  t("pages.features.website.businesses.clothingStore"),
  t("pages.features.website.businesses.lawyer"),
  t("pages.features.website.businesses.barber"),
  t("pages.features.website.businesses.carWash"),
  t("pages.features.website.businesses.fitness"),
  t("pages.features.website.businesses.notary"),
  t("pages.features.website.businesses.photoStudio"),
  t("pages.features.website.businesses.billiards"),
  t("pages.features.website.businesses.yourBusiness"),
]);

const ADVANTAGES = computed(() => [
  {
    description: t("pages.features.website.cards.management.description"),
    image: "website-card-3",
    title: t("pages.features.website.cards.management.title"),
  },
  {
    description: t("pages.features.website.cards.pages.description"),
    image: "website-card-4",
    title: t("pages.features.website.cards.pages.title"),
  },
]);

useSeoMeta({
  title: t("pages.features.website.seo.title"),
});
</script>

<style scoped>
.website__wrapper {
  display: flex;
  flex-direction: column;
  row-gap: 80px;
  margin: 0 auto 80px;
  padding: 0 24px;
}

@media (--desktop) {
  .website__wrapper {
    row-gap: 120px;
    margin-bottom: 120px;
  }
}

.website__cards {
  display: grid;
  row-gap: 16px;
}

@media (--desktop) {
  .website__cards {
    grid-template-columns: repeat(2, 1fr);
    column-gap: 20px;
  }
}
</style>
